import { QuickButtonComplexContentType } from '../../../../../../components/quickButtonComplex/types/content';
import { QuickButtonComplexVariantType } from '../../../../../../components/quickButtonComplex/types/quickButtonComplex';
import { QuickButtonComplexState } from '../../../../../../components/quickButtonComplex/types/state';
import { commonStyles, disabledCommonStyles } from '../commonStyles';
export const getImageStyles = (FOUNDATIONS, FONT) => {
    return {
        [QuickButtonComplexVariantType.IMAGE]: {
            [QuickButtonComplexContentType.WITH_ICON]: {
                [QuickButtonComplexState.DEFAULT]: {
                    ...commonStyles(FOUNDATIONS, FONT),
                    icon: {
                        ...commonStyles(FOUNDATIONS, FONT).icon,
                        color: FOUNDATIONS.color_comp_actions_quickbutton_primary_default_icon,
                    },
                },
                [QuickButtonComplexState.PRESSED]: {
                    ...commonStyles(FOUNDATIONS, FONT),
                    quickButtonComplex: {
                        ...commonStyles(FOUNDATIONS, FONT).quickButtonComplex,
                        background_color: FOUNDATIONS.color_comp_actions_quickbutton_primary_pressed_bg,
                        border_color: FOUNDATIONS.color_comp_actions_quickbutton_primary_pressed_border,
                    },
                    icon: {
                        ...commonStyles(FOUNDATIONS, FONT).icon,
                        color: FOUNDATIONS.color_comp_actions_quickbutton_primary_pressed_icon,
                    },
                    label: {
                        ...commonStyles(FOUNDATIONS, FONT).label,
                        color: FOUNDATIONS.color_comp_actions_quickbutton_primary_pressed_label,
                    },
                },
                [QuickButtonComplexState.DISABLED]: {
                    ...disabledCommonStyles(FOUNDATIONS, FONT),
                },
            },
            [QuickButtonComplexContentType.WITH_IMAGE]: {
                [QuickButtonComplexState.DEFAULT]: {
                    ...commonStyles(FOUNDATIONS, FONT),
                    quickButtonComplex: {
                        ...commonStyles(FOUNDATIONS, FONT).quickButtonComplex,
                        background_color: FOUNDATIONS.color_neutral_bg_onsurface_200,
                        border_color: FOUNDATIONS.color_comp_actions_quickbutton_image_default_border,
                        background_size: 'cover',
                        background_position: 'center',
                        background_repeat: 'no-repeat',
                        width: FOUNDATIONS.size_500,
                        height: FOUNDATIONS.size_500,
                    },
                    label: {
                        ...commonStyles(FOUNDATIONS, FONT).label,
                        color: FOUNDATIONS.color_exception_neutral_font_350,
                    },
                },
                [QuickButtonComplexState.PRESSED]: {
                    ...commonStyles(FOUNDATIONS, FONT),
                    quickButtonComplex: {
                        ...commonStyles(FOUNDATIONS, FONT).quickButtonComplex,
                        background_color: FOUNDATIONS.color_neutral_bg_onsurface_200,
                        border_color: FOUNDATIONS.color_neutral_border_50,
                        background_size: 'cover',
                        background_position: 'center',
                        background_repeat: 'no-repeat',
                        width: FOUNDATIONS.size_500,
                        height: FOUNDATIONS.size_500,
                    },
                    label: {
                        ...commonStyles(FOUNDATIONS, FONT).label,
                        color: FOUNDATIONS.color_exception_neutral_font_350,
                    },
                },
                [QuickButtonComplexState.DISABLED]: {
                    ...commonStyles(FOUNDATIONS, FONT),
                    container: {
                        ...commonStyles(FOUNDATIONS, FONT).container,
                        cursor: 'default',
                    },
                    quickButtonComplex: {
                        ...commonStyles(FOUNDATIONS, FONT).quickButtonComplex,
                        background_color: FOUNDATIONS.color_neutral_bg_onsurface_200,
                        border_color: FOUNDATIONS.color_accent_disabled_border_100,
                        background_size: 'cover',
                        background_position: 'center',
                        background_repeat: 'no-repeat',
                        width: FOUNDATIONS.size_500,
                        height: FOUNDATIONS.size_500,
                    },
                    label: {
                        ...commonStyles(FOUNDATIONS, FONT).label,
                        color: FOUNDATIONS.color_accent_disabled_font_100,
                    },
                },
            },
            [QuickButtonComplexContentType.WITH_INITIALS]: {
                [QuickButtonComplexState.DEFAULT]: {
                    ...commonStyles(FOUNDATIONS, FONT),
                },
                [QuickButtonComplexState.PRESSED]: {
                    ...commonStyles(FOUNDATIONS, FONT),
                    quickButtonComplex: {
                        ...commonStyles(FOUNDATIONS, FONT).quickButtonComplex,
                        background_color: FOUNDATIONS.color_comp_actions_quickbutton_primary_pressed_bg,
                        border_color: FOUNDATIONS.color_comp_actions_quickbutton_primary_pressed_border,
                    },
                    initials: {
                        ...commonStyles(FOUNDATIONS, FONT).initials,
                        color: FOUNDATIONS.color_comp_actions_quickbutton_primary_pressed_initials,
                    },
                },
                [QuickButtonComplexState.DISABLED]: {
                    ...commonStyles(FOUNDATIONS, FONT),
                    container: {
                        ...commonStyles(FOUNDATIONS, FONT).container,
                        cursor: 'default',
                    },
                    quickButtonComplex: {
                        ...commonStyles(FOUNDATIONS, FONT).quickButtonComplex,
                        background_color: FOUNDATIONS.color_accent_disabled_bg_100,
                        border_color: FOUNDATIONS.color_neutral_border_200,
                    },
                    initials: {
                        ...commonStyles(FOUNDATIONS, FONT).initials,
                        color: FOUNDATIONS.color_accent_disabled_font_100,
                    },
                },
            },
        },
    };
};
//# sourceMappingURL=image.js.map